// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"d00d9af1","359":"7affed8d","529":"4cb407a4"}[chunkId] + ".chunk.js";
};